import { SerializedStyles } from "@emotion/react";
import { css } from "@emotion/react/macro";

import theme from "../../styles/theme";
import { greyLight } from "../../styles/variables";

export const controllers = css`
  display: none;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
`;

export const container = (disabled?: boolean): SerializedStyles => css`
  position: relative;
  width: 360px;
  height: 200px;
  border-radius: 4px;
  background: ${greyLight};

  &:hover .css-${controllers.name} {
    display: ${!disabled && "block"};
  }
`;

export const input = css`
  display: none;
`;

export const remove = css`
  display: block;
  margin: ${theme.spacing(1.5)}px auto 0 auto;
`;

export const img = css`
  width: inherit;
  height: inherit;
`;

export const error = css`
  margin-top: 3px;
`;
